var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mt-5 mr-2 ml-2"},[_c('h1',[_vm._v("Page not found..")])])
}]

export { render, staticRenderFns }